import './assets/schoolshub/app.scss';

export default () => null;
